module.exports = __webpack_public_path__ + "static/media/sateur.5b5a3309.png";